module.exports = __webpack_public_path__ + "static/media/boost-hero-mobile.f46991cd.svg";